import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import { MixedContentCardWithBookmark } from '../../cards/MixedContentCardWithBookmark/MixedContentCardWithBookmark';

export const BookmarksWithGrid = ({ id, href, type, ...props }) => {
  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 4"
      columnEndXl="span 3"
      key={id}
    >
      <MixedContentCardWithBookmark
        id={id}
        href={href}
        type={type}
        linkVariables={{
          href,
          category: 'Profiel_ingelogd',
          action: 'click',
          label: `Bewaarde_${type}_${id}`,
        }}
        {...props}
      />
    </GridItem>
  );
};

BookmarksWithGrid.propTypes = {
  id: PropTypes.number.isRequired,
  href: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
